export default __webpack_public_path__ + "static/media/CV-ENGL 2021 TPW web[3675].0960a20a.pdf";